<mat-expansion-panel
	class="au-section-panel au-section-inherit-bg"
	hideToggle
	[expanded]="expanded"
	[disabled]="!panelCanBeExpanded"
	(afterCollapse)="afterCollapseHandler()"
	(afterExpand)="afterExpandHandler()"
>
	<mat-expansion-panel-header class="section-header">
		<mat-panel-title>
			<span class="arrow" [class.rotate-right-90]="!expanded">
				<mat-icon
					[ngClass]="expanded ? '' : 'ghost-grey-icon'"
					svgIcon="arrow_down"
				></mat-icon>
			</span>

			<ng-content select="[panel-title]"></ng-content>
		</mat-panel-title>

		<mat-panel-description class="description">
			<ng-content select="[panel-description]"></ng-content>
		</mat-panel-description>
	</mat-expansion-panel-header>

	<ng-content select="[panel-content]"></ng-content>
</mat-expansion-panel>
